import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Store from './store';
import { initialState } from './store/reducer';
import { prepareQuestionnaireData } from './utils/data';
import Brief from './components/Brief';

// export const useQuery = () => {
//   const { search } = useLocation();
//
//   return React.useMemo(() => new URLSearchParams(search), [search]);
// };
//
// export async function loader({ request }) {
//   const url = new URL(request.url);
//   const q = url.searchParams.get("q");
//   return { q };
// }

export default props => {
  // const history = createBrowserHistory();
  // let query = useQuery();
  // const { q } = useLoaderData();
  // const location = useLocation();
  // console.log(location);

  // Seed the store with the questionnaire data on the very first render (mirrors
  // the `prepareQuestionnaireData` dispatch Brief runs in useEffect). Without this
  // the first paint shows an empty rooms grid and the footer jumps down once the
  // effect injects the rooms — a ~0.2 CLS on `.brief_footer`.
  const { form, initialQuestion, ...dataProps } = props;
  const preloadedState = {
    gettingStarted: {
      ...initialState.gettingStarted,
      ...prepareQuestionnaireData(dataProps),
    },
  };

  return (
    <Store preloadedState={preloadedState}>
      {/*<Brief question={query.get('q')} {...props} />*/}
      {/*<Brief {...props} />*/}
      {/*<Router history={history}>*/}
      <Router>
        <Route exact path="/getting_started/step1" children={<Brief {...props} />} />
        {/*<Route exact path="/getting_started/step1?question=you_receive" children={<Brief {...props} initialQuestion='you_receive' />} />*/}
        <Route exact path="/getting_started/step2" children={<Brief {...props} initialQuestion='plan' />} />
        <Route exact path="/getting_started/step3" children={<Brief {...props} initialQuestion='address' />} />
        {/*/!*<Route exact path="/getting_started/step3" children={ <Brief {...props} />}  />*!/*/}
        {/*/!*<Route path="/step:id" component={Component} />*!/*/}
        {/*/!*<Route path="/smile" component={Component} />*!/*/}
        {/*/!*<Route path="/think" component={Component} />*!/*/}
        {/*/!*<Route path="/thumbs" component={Component} />*!/*/}
        {/*/!*<Route path="/excited" component={Component} />*!/*/}
      </Router>
    </Store>
  );
}


// WEBPACK FOOTER //
// ./app/javascript/components/brief/index.js